import { useChatContext } from './ChatContext';

const useDynamicItemDetail = () => {
    const { showDynamicItemDetail, setShowDynamicItemDetail } = useChatContext();
    return { showDynamicItemDetail, setShowDynamicItemDetail };
};

export default useDynamicItemDetail;
